import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';

const PriceAmounts = ({ price }) => {
    const lang = document.documentElement.lang;
    const showBefore = lang !== 'fr';

    const removeDollarSign = (value) => (isString(value) ? value.replace('$', '') : value);

    return (
        <>
            {showBefore && <span className="currency-symbol">$</span>}
            {price && <span className="currency-value">{removeDollarSign(price)}</span> }
            {!showBefore && <span className="currency-symbol fr">$</span>}
        </>
    );
};

PriceAmounts.propTypes = {
    price: PropTypes.string,
};

PriceAmounts.defaultProps = {
    price: '',
};

export default PriceAmounts;
